// 通用配置
const config = {
  // 网站标题
  title:'一分收获',
  // Message与Notify 消息提示显示时间
  duration: 3000,
  // ICP备案号
  ICP:'x',
  // 公安联网备案号
  GALW:'x',
  // 菜单上方项目名称
  ProjectName:'一分收获',
};
export default config;
